import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {CookieConsentBannerComponent} from '../components/dumb/cookie-consent-banner/cookie-consent-banner.component';

@Component({
  standalone: true,
  selector: 'app-shell',
  templateUrl: './app-shell.component.html',
  imports: [RouterOutlet, CookieConsentBannerComponent],
})
export class AppShellComponent {}
